import axiosClient from "../../../../../../../../../../../axiosClient"

export default async (id, serviceId) => {
    const result = await axiosClient.get(`/icover-service-details/${id}/icover-service/${serviceId}`)

    return {
        provided: flattenFields(result.data.provided),
        verified: flattenFields(result.data.verified),
    }
}

// from ChatGPT
const flattenFields = (list) => {
    const result = [];

    for (const item of list) {
        if (Array.isArray(item.value)) {
            // Recursively flatten nested array of fields
            const flattened = flattenFields(item.value);
            result.push(...flattened);
        } else {
            result.push(item);
        }
    }

    return result;
}
